"use client";

import React, { useEffect, useRef, useState } from "react";

import WalkthroughVideo from "@/components/Walkthrough";

export default function ProjectWalkthrough({ projectDetail }) {
  const sectionRef = useRef(null);

  const observerRef = useRef(null);

  const hasAnimated = useRef(false);

  const [active, setActive] = useState(false);

  const [inView, setInView] = useState(false);

  /* RESET WHEN PROJECT CHANGES */

  useEffect(() => {
    setActive(false);

    setInView(false);

    hasAnimated.current = false;
  }, [projectDetail?.project_id]);

  /* OBSERVER */

  useEffect(() => {
    const element = sectionRef.current;

    if (!element) return;

    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting;

        setInView(visible);

        /* trigger once */

        if (visible && !hasAnimated.current) {
          setActive(true);

          hasAnimated.current = true;
        }
      },
      {
        threshold: 0.25,
        rootMargin: "-10% 0px -10% 0px",
      },
    );

    observerRef.current.observe(element);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [projectDetail?.project_id]);

  if (!projectDetail) return null;

  const walkthroughVideos =
    projectDetail?.project_id !== "759"
      ? projectDetail?.virtual_data?.filter(
          (video) => video.type === "walk-through" && video.image !== "",
        ) || []
      : [];

  const bannerImage = projectDetail?.banner_data?.image_web_full;

  const getBannerUrl = (url, width) => {
    if (!url) return "";

    const separator = url.includes("?") ? "&" : "?";

    return `${url}${separator}w=${width}&q=100`;
  };

  /* FALLBACK IMAGE */

  if (!walkthroughVideos.length) {
    if (!bannerImage) return null;

    return (
      <section
        key={projectDetail?.project_id}
        ref={sectionRef}
        className={`
        walkthrough-section
        walkthrough-banner-fallback
        ${active ? "walkthrough-active" : ""}
      `}
      >
        <div
          className="
        walkthrough-wrapper
        "
        >
          <div
            className="
          walkthrough-video-box
          "
          >
            <img
              src={getBannerUrl(bannerImage, 2560)}
              alt={projectDetail?.project_title}
              className="
              hide-tab-mobile
              "
            />

            <img
              src={getBannerUrl(bannerImage, 991)}
              alt={projectDetail?.project_title}
              className="
              visible-tab-mobile
              "
            />
          </div>
        </div>
      </section>
    );
  }

  /* WALKTHROUGH */

  return (
    <section
      key={projectDetail?.project_id}
      ref={sectionRef}
      className={`
      walkthrough-section
      ${active ? "walkthrough-active" : ""}
    `}
    >
      <div
        className="
      walkthrough-wrapper
      "
      >
        <div
          className="
        walkthrough-video-box
        "
        >
          <WalkthroughVideo
            virtualDataArray={walkthroughVideos[0]?.url}
            shouldPlay={inView}
          />
        </div>
      </div>
    </section>
  );
}
